import {
   Component,
   Input,
   OnChanges,
   OnDestroy,
   OnInit,
   SimpleChanges,
   ViewChild
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { Subject, of } from 'rxjs';
import { exhaustMap, finalize, startWith, takeUntil } from 'rxjs/operators';
import { PhobosTaskInstanceService } from '../../../services/phobos-task-instance.service';
import { AiProcessingTask } from '../../../domain/Ai/ai-processing-task';

@Component({
   selector: 'app-is-ai-tasks-processing',
   standalone: true,
   templateUrl: './is-ai-tasks-processing.component.html',
   styleUrls: ['./is-ai-tasks-processing.component.scss'],
   imports: [CommonModule, OverlayPanelModule]
})
export class IsAiTasksProcessingComponent implements OnInit, OnChanges, OnDestroy {
   @Input() propertyId!: number;
   @Input() activeColor = 'red';
   @Input() isPendingOnly = true;
   @Input() iconSizeClass = 'text-2xl';

   tasks: AiProcessingTask[] = [];
   count = 0;
   isRefreshing = false;

   private readonly destroy$ = new Subject<void>();
   private readonly manualRefresh$ = new Subject<void>();

   @ViewChild('panel') panel!: OverlayPanel;

   constructor(private phobosService: PhobosTaskInstanceService) {}

   ngOnInit(): void {
      this.manualRefresh$
         .pipe(
            startWith(void 0), // initial load
            exhaustMap(() => {
               if (!this.propertyId) return of<AiProcessingTask[]>([]);

               this.isRefreshing = true;
               return this.phobosService
                  .isAiTasksProcessing(this.propertyId, this.isPendingOnly)
                  .pipe(finalize(() => (this.isRefreshing = false)));
            }),
            takeUntil(this.destroy$)
         )
         .subscribe((tasks) => {
            this.tasks = tasks ?? [];
            this.count = this.tasks.length;
         });
   }

   ngOnChanges(changes: SimpleChanges): void {
      if (changes['propertyId'] && !changes['propertyId'].firstChange) {
         this.refreshNow();
      }
   }

   togglePanel(event: Event) {
      if (this.panel) this.panel.toggle(event);
   }

   refreshNow() {
      this.manualRefresh$.next();
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }
}
